import React, { createContext, useContext } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { askAI, getSessionId, getConversation } from '../Services/aiService';

const AiContext = createContext();

export const AiProvider = ({ children }) => {
  const queryClient = useQueryClient();

  // 🔹 Charger la conversation existante
  const { data: conversation = [], isLoading, refetch } = useQuery({
    queryKey: ['conversation'],           // anciennement premier argument
    queryFn: async () => {                // anciennement deuxième argument
      const sessionId = getSessionId();
      const previousConversation = await getConversation(sessionId);
      if (!previousConversation) return [];

      const formatted = [];
      previousConversation.forEach(item => {
        formatted.push({ role: 'user', message: item.question });
        formatted.push({ role: 'ai', message: item.answer });
      });
      return formatted;
    }
  });

  // 🔹 Envoyer un message à l'AI
  const sendMessageMutation = useMutation({
    mutationFn: async (message) => {
      const sessionId = getSessionId();
      const userMsg = { role: 'user', message };
      const answer = await askAI(message, sessionId);
      const aiMsg = { role: 'ai', message: answer };
      return [userMsg, aiMsg];
    },
    onSuccess: (newMessages) => {
      queryClient.setQueryData(['conversation'], (old = []) => [...old, ...newMessages]);
    }
  });

  const sendMessage = async (message) => {
    await sendMessageMutation.mutateAsync(message);
  };

  return (
    <AiContext.Provider value={{ conversation, sendMessage, isLoading, refetch }}>
      {children}
    </AiContext.Provider>
  );
};

export const useAI = () => useContext(AiContext);